import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IdNameMxObj} from 'mx-core';

const REST_URL: string = '/rest/profiles';

@Injectable({
    providedIn: 'root'
})
export class PrlProfilesService {

    private nonExpiredCampaigns: IdNameMxObj[];

    public getNonExpiredCampaigns(): IdNameMxObj[] {
        return this.nonExpiredCampaigns;
    }

    public setNonExpiredCampaigns(value: IdNameMxObj[]) {
        this.nonExpiredCampaigns = value;
    }

    constructor(private readonly httpClient: HttpClient) {
    }

    public getCampaigns(): Observable<IdNameMxObj[]> {
        return this.httpClient.get<IdNameMxObj[]>(REST_URL + '/campaigns');
    }

    public loadNonExpiredCampaigns(): Observable<IdNameMxObj[]> {
        return this.httpClient.get<IdNameMxObj[]>(REST_URL + '/campaigns/non-expired');
    }

    public createProfile(profile): Observable<void> {
        return this.httpClient.post<void>(REST_URL, profile);
    }
}
